<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
  <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
  <!--begin::Content wrapper-->
  <div class="d-flex flex-column flex-column-fluid">
    <!--begin::Toolbar-->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <!--begin::Toolbar container-->
      <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <!--begin::Title-->
          <div class="masse d-flex align-items-center">
            <h1 class="page-heading">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="31" viewBox="0 0 48 31" fill="none">
                <g filter="url(#filter0_d_859_2196)">
                  <path
                    d="M16.7128 14.7991C16.4554 14.7287 16.2221 14.5901 16.0377 14.3981C15.8533 14.206 15.7247 13.9677 15.6657 13.7086C15.6067 13.4495 15.6194 13.1793 15.7026 12.9268C15.7858 12.6743 15.9362 12.4491 16.1379 12.2751C16.4977 11.975 16.7871 11.6 16.9857 11.1767C17.1844 10.7533 17.2874 10.2917 17.2877 9.8244V3.95451C17.2877 3.10081 16.948 2.28186 16.3431 1.67683C15.7381 1.07181 14.917 0.729955 14.0595 0.726074H11.4947C10.6359 0.729935 9.8133 1.07131 9.20599 1.67593C8.59868 2.28054 8.25577 3.09947 8.2519 3.95451V9.8244C8.25493 10.2927 8.36072 10.7546 8.56186 11.178C8.76301 11.6013 9.05465 11.9757 9.41637 12.2751C9.61819 12.4481 9.76916 12.6722 9.85325 12.9238C9.93734 13.1753 9.95141 13.4449 9.89396 13.7037C9.83651 13.9626 9.70969 14.2012 9.52698 14.394C9.34426 14.5869 9.11247 14.7269 8.85625 14.7991C7.27929 15.2748 5.92783 16.3013 5.05039 17.6898C4.17295 19.0783 3.82851 20.7355 4.08041 22.3566H21.4591C21.7126 20.7393 21.3723 19.0852 20.5006 17.6973C19.629 16.3094 18.2843 15.2805 16.7128 14.7991Z"
                    fill="#265D91" />
                  <path
                    d="M42.2279 10.6315H39.9432C39.6542 9.41197 39.0271 8.29777 38.1332 7.41568C37.2394 6.5336 36.1147 5.91907 34.8873 5.64206V3.30878C34.8873 2.91958 34.732 2.54633 34.4556 2.27112C34.1791 1.99592 33.8042 1.84131 33.4133 1.84131C33.0223 1.84131 32.6474 1.99592 32.371 2.27112C32.0946 2.54633 31.9393 2.91958 31.9393 3.30878V5.64206C30.6983 5.90677 29.558 6.51583 28.6502 7.39879C27.7425 8.28175 27.1043 9.40252 26.8097 10.6315H24.5839C24.3903 10.6315 24.1986 10.6694 24.0198 10.7432C23.841 10.8169 23.6785 10.925 23.5416 11.0613C23.4047 11.1975 23.2961 11.3593 23.2221 11.5374C23.148 11.7154 23.1099 11.9062 23.1099 12.0989C23.1099 12.2916 23.148 12.4825 23.2221 12.6605C23.2961 12.8386 23.4047 13.0003 23.5416 13.1366C23.6785 13.2729 23.841 13.3809 24.0198 13.4547C24.1986 13.5284 24.3903 13.5664 24.5839 13.5664H26.8097C27.09 14.7986 27.715 15.9265 28.6123 16.8199C29.5096 17.7132 30.6426 18.3354 31.8803 18.6145V20.8891C31.8803 21.2783 32.0356 21.6515 32.312 21.9267C32.5885 22.2019 32.9634 22.3566 33.3543 22.3566C33.7453 22.3566 34.1202 22.2019 34.3966 21.9267C34.673 21.6515 34.8283 21.2783 34.8283 20.8891V18.6145C36.0633 18.333 37.1932 17.7097 38.0877 16.8165C38.9823 15.9233 39.605 14.7967 39.8842 13.5664H42.169C42.5599 13.5742 42.9379 13.427 43.2199 13.1573C43.5019 12.8876 43.6647 12.5175 43.6725 12.1283C43.6803 11.7391 43.5325 11.3627 43.2616 11.082C42.9907 10.8013 42.6189 10.6392 42.2279 10.6315ZM31.9098 15.5475C31.0065 15.1744 30.2866 14.4629 29.9051 13.5664H31.9098V15.5475ZM31.9098 10.6315H29.9346C30.3251 9.74109 31.0421 9.03256 31.9393 8.65037L31.9098 10.6315ZM34.8578 15.5475V13.5664H36.8478C36.4704 14.4504 35.7696 15.1586 34.8873 15.5475H34.8578ZM34.8578 10.6315V8.65037C35.7478 9.03807 36.4583 9.74544 36.8478 10.6315H34.8578Z"
                    fill="#265D91" />
                </g>
                <defs>
                  <filter id="filter0_d_859_2196" x="0" y="0.726074" width="47.6729" height="29.6306"
                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha" />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_859_2196" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_859_2196" result="shape" />
                  </filter>
                </defs>
              </svg>

              Nos Fournisseurs
            </h1>
            <div class="tools">
              <div class="dropdown">
                <button class="masse-btn dropdown-toggle" type="button" id="dropdownMenuButton"
                  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_588_1703)">
                      <circle cx="20" cy="18" r="13" fill="white" />
                    </g>
                    <path d="M19.6667 13V23" stroke="#265D91" stroke-width="2" stroke-linecap="round" />
                    <path d="M15 18.3333H25" stroke="#265D91" stroke-width="2" stroke-linecap="round" />
                    <defs>
                      <filter id="filter0_d_588_1703" x="0" y="0" width="42" height="42" filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha" />
                        <feOffset dx="1" dy="3" />
                        <feGaussianBlur stdDeviation="4" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_588_1703" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_588_1703" result="shape" />
                      </filter>
                    </defs>
                  </svg>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" (click)="openModaladd(add_update_Supplier)">Ajout Fournisseur</a>
                  <!-- <a class="dropdown-item" (click)="openModaladdindiv(add_update_Supplier_Individual)">Ajout Type
                    Individuel</a> -->
                  <a class="dropdown-item" (click)="downloadCsv()">Télécharger un modèle d'ajout en masse</a>
                  <a class="dropdown-item" (click)="openModalBulk(add_masse)">Ajout en masse</a>
                </div>
              </div>
            </div>
            <!--begin::Menu-->
          </div>
          <!--end::Title-->
          <!--begin::Breadcrumb-->
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">
              <a routerLink="/accueil" class="text-muted ">Accueil</a>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">Nos Fournisseurs</li>
            <!--end::Item-->
          </ul>
          <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
      </div>
      <!--end::Toolbar container-->
    </div>
    <!--end::Toolbar-->
    <div id="kt_app_content" class="app-content flex-column-fluid mb-15">
      <!--begin::Content container-->
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
          <!--begin::Card header-->
          <form [formGroup]="searchForm" >
            <div class="card-body">
              <div class="title mb-10">
                <h4>Recherche</h4>
              </div>
              <div class="row mb-5">
                <div class="col-lg-6">
                  <div class="input-group search-libre">
                    <span class="input-group-text">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                          d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                          fill="#7E7C7C" />
                      </svg>
                    </span>

                    <input type="text" data-kt-customer-table-filter="search" class="form-control ps-5"
                      placeholder="Rechercher" formControlName="search" (keyup.enter)="searchfournisseur()"/>
                    <div class="tooltip-container tooltip-info">
                      <div class="tooltip-trigger"><i class="fa-solid fa-circle-info" style="font-size: 20px;"></i>
                      </div>
                      <div class="tooltip-content">
                        <div class="content">
                          <h4>Opérateur AND :</h4>
                          <p>Utilisez l'opérateur AND pour spécifier que les résultats doivent inclure plusieurs termes.
                          </p>
                          <p>Exemple : software AND engineer renverra des profils qui mentionnent à la fois "software"
                            et "engineer".
                          </p>
                          <h4>Opérateur OR :</h4>
                          <p>Utilisez l'opérateur OR pour spécifier que les résultats peuvent inclure l'un des termes.
                          </p>
                          <p>Exemple : sales OR marketing renverra des profils qui mentionnent soit "sales" soit
                            "marketing".
                          </p>
                          <h4>Opérateur NOT :</h4>
                          <p>Utilisez l'opérateur NOT pour exclure des termes spécifiques des résultats.
                          </p>
                          <p>Exemple : developer NOT manager renverra des profils qui mentionnent "developer" mais pas
                            "manager".
                          </p>
                          <h4>Guillemets pour une expression exacte :</h4>
                          <p>Utilisez des guillemets pour rechercher une expression exacte.
                          </p>
                          <p>Exemple : "product manager" renverra des profils qui mentionnent exactement "product
                            manager".
                          </p>
                          <h4>Parenthèses pour grouper des opérations :</h4>
                          <p>Utilisez des parenthèses pour définir l'ordre d'évaluation des opérations.
                          </p>
                          <p>Exemple : (sales OR marketing) AND manager renverra des profils qui mentionnent "sales" ou
                            "marketing" et "manager".
                          </p>
                          <h4>Recherche standard :</h4>
                          <p>Si aucun opérateur n'est spécifié dans la recherche, le texte sera interprété comme s'il
                            était entre guillemets.
                          </p>
                          <p>Exemple : La recherche product manager sera traitée comme "product manager", suivant la
                            règle 4.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="filter-tools mt-10 mb-10">
                <div class="filter">

                  <!-- <div class="form-check mr2">
                    <input class="form-check-input" type="radio" name="drone" value="1" (change)="sortType($event)"
                      id="flexCheckDefault" checked />
                    <label class="form-check-label" for="flexCheckDefault">
                      ESN
                    </label>
                  </div> -->
                  <!-- <div class="form-check mr2">
                    <input class="form-check-input" type="radio" name="drone" value="2" (change)="sortType($event)"
                      id="flexCheckDefault" />
                    <label class="form-check-label" for="flexCheckDefault">
                      individuel (Freelancer)
                    </label>
                  </div> -->
                </div>
              </div>
              <div class="tools" *ngIf="type == 2">
                <div class="row mb-3">

                  <div class="col-lg-3">
                    <input type="text" formControlName="consultant_name" id="Nom"
                      class="form-control form-control-solid mb-3" placeholder="Nom" />
                  </div>
                  <div class="col-lg-3 rechercher">
                    <div class="mb-3 search-btn d-flex">
                      <div class="align-items-center recherche">
                        <button type="button" class="me-5" (click)="searchfournisseur()">
                          <svg width="15" height="15" viewBox="0 0 20 20" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                              fill="white" />
                          </svg>
                          Rechercher</button>
                      </div>
                      <div class="resett-btn">
                        <div class="reset-icon cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top"
                          title="Réinitialiser">
                          <a (click)="reset()"> <img src="/assets/media/icons/reset.png" alt="" width="30px"></a>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>

              </div>
              <div class="tools" *ngIf="type == 1">
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <input type="text" formControlName="name" id="Nom" class="form-control form-control-solid mb-3"
                      placeholder="ESN">
                  </div>
                  <div class="col-lg-3">
                    <input type="text" formControlName="consultant_name" id="Nom"
                      class="form-control form-control-solid mb-3" placeholder="Nom consultant" />
                  </div>
                  <div class="col-lg-3 rechercher">
                    <div class="mb-3 search-btn d-flex">
                      <div class="align-items-center recherche">
                        <button type="button" class="me-5" (click)="searchfournisseur()">
                          <svg width="15" height="15" viewBox="0 0 20 20" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                              fill="white" />
                          </svg>
                          Rechercher</button>
                      </div>
                      <div class="resett-btn">
                        <div class="reset-icon cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top"
                          title="Réinitialiser">
                          <a (click)="reset()"> <img src="/assets/media/icons/reset.png" alt="" width="30px"></a>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>

              </div>
            </div>
          </form>
        </div>
      </div>
      <!--end::Content container-->
    </div>
    <!--begin::Content-->

    <div *ngIf="!isLoadSpinner" id="kt_app_content" class="app-content flex-column-fluid mb-5">
      <!--begin::Content container-->
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
          <!--begin::Card header-->
          <div class="d-flex flex-wrap my-1 header-grid align-items-center">
            <div class="section_title">
              <h1 class="section-heading my-0">Liste des fournisseurs</h1>
            </div>
            <!--begin::Tab nav-->
            <div class="grid-list">
              <ul class="nav nav-pills me-5">
                <li class="nav-item m-0">
                  <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary me-3" data-bs-toggle="tab"
                    href="#kt_project_targets_card_pane">
                    <i class="ki-duotone ki-element-plus fs-1">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                      <span class="path4"></span>
                      <span class="path5"></span>
                    </i>
                  </a>
                </li>
                <li class="nav-item m-0">
                  <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active"
                    data-bs-toggle="tab" href="#kt_project_targets_table_pane">
                    <i class="ki-duotone ki-row-horizontal fs-2">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </i>
                  </a>
                </li>
              </ul>
            </div>
            <!--end::Tab nav-->
            <!--begin::Wrapper-->

            <!--end::Wrapper-->
          </div>


          <!--end::Card header-->
          <!--begin::Card body-->
          <div class="card-body pt-0" *ngIf="type == 2">
            <div class="tab-content">
              <!--begin::Tab pane-->

              <div id="kt_project_targets_card_pane" class="tab-pane fade">
                <!--begin::Row-->
                <div class="row g-6 g-xl-9 justify-content-center">
                  <!--begin::Col-->
                  <div class="row g-6 g-xl-9 justify-content-center">
                    <!--begin::Col-->
                    <div class="col-md-6 col-xxl-4" *ngFor="let f of listfournisseurs">
                      <!--begin::Card-->
                      <div class="card pt-5 p-5">
                        <div class="tools">
                          <div class="dropdown">
                            <button
                              class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                              type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                              aria-expanded="false">
                              <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)"
                                  fill="#265D91" />
                                <circle cx="2.44739" cy="2.44739" r="2.44739"
                                  transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                                <circle cx="2.44739" cy="2.44739" r="2.44739"
                                  transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                              </svg>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                              <a class="cc dropdown-item" (click)="profilFourNavigation(f.company?.id)">Voir Détail </a>
                              <a class="cc dropdown-item" (click)="dissociateSupplier(f.company?.id,'user_id')">Dissocier </a>
                              <!-- <a class="cc dropdown-item" *ngIf="type=='1'"
                                (click)="openModal(update_Supplier,f)">Modifier </a> -->

                              <a class="dropdown-item" routerLink="/contacter-nous">Contact </a>
                            </div>
                          </div>
                        </div>
                        <!--begin::Card body-->
                        <div class="card-body d-flex flex-center flex-column">
                          <!--begin::Avatar-->
                          <div class="symbol symbol-65px symbol-circle mb-5">

                            <img class="table-img logo-img" src="{{f?.image_url?url+'/Company/file/gallery_company/'+ f?.image_url:'/assets/media/icons/avatar.jpg'
                                }}" alt="">
                          </div>

                          <span class="mb-3 company-name">{{f.first_name}}{{f.last_name}}</span>


                          <div class="content-card">
                            <!-- <div class="py-3 px-4 mx-2">
                              <span
                                class="badge-annee">{{f.Nombre_jours_de_prestation?f.Nombre_jours_de_prestation:'---'}}
                                Jours
                                préstation</span>
                            </div> -->



                            <div class="py-3 px-4 mx-2">
                              <div class="stars text-center">
                                <rating [(ngModel)]="f.average_note" [max]="5" [readonly]="true">
                                </rating>
                              </div>
                            </div>


                          </div>

                        </div>
                        <div class="foot p-3">
                          <div class="poste">
                            <span class="badge hybrid cursor-pointer" (click)="redirectToSite(f.linkedin_link)">Linkedin
                            </span>
                          </div>
                          <div class="plus cursor-pointer">
                            <a (click)="profilFourNavigation(f.id)">Voir plus</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="alert alert-warning text-center mt-5" role="alert"
                      *ngIf="listfournisseurs && !listfournisseurs.length">
                      <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                      <span class="empty-list">
                        La liste est vide
                      </span>
                    </div>
                  </div>

                </div>
              </div>



              <div id="kt_project_targets_table_pane" class="tab-pane fade show active">
                <div class="content">
                  <div class="card-body pt-3">
                    <!--begin::Table-->
                    <div class="table-responsive">
                      <table class="table align-middle fs-6 gy-5 style-table" id="kt_customers_table">
                        <thead>
                          <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">

                            <ng-container *ngFor="let item of listNamesIndiv ;let i =index">
                              <th class="min-w-225px" [ngClass]="{'th-fixed': item === 'Entreprise'}">
                                <span>{{item.name}}</span>
                                <i *ngIf="item.item != 'logo' " (click)="sortData(item.item)"
                                  class="fa-solid fa-sort cursor-pointer"></i>
                              </th>
                            </ng-container>

                            <th class="min-w-90px"><span>Actions</span></th>

                          </tr>


                        </thead>

                        <tbody class="fw-semibold text-gray-600">
                          <tr *ngFor="let f of listfournisseurs">
                            <td> 
                              <!-- <img class="table-img logo-img" src="{{f?.image_url?url+'/Company/file/gallery_company/'+ f?.image_url:'/assets/media/icons/avatar.jpg'
                            }}" alt=""> -->
                            <img *ngIf="f?.company?.logo" class="table-img logo-img"
                            src="{{url+'/Company/file/gallery_company/'+ f?.company.logo}}"
                            alt="">
                        <img *ngIf="!f.company.logo" class="table-img logo-img"
                            src="/assets/media/icons/avatar.jpg" alt="">

                            </td>
                            <td>
                              {{f?.first_name?f?.first_name:'---'}}  {{f?.last_name?f?.last_name:'---'}}</td>
                            <!-- <td>
                              {{f?.last_name?f?.last_name:'---'}}</td> -->

                         
                            <!-- <td>
                              {{f?.Nombre_jours_de_prestation?f?.Nombre_jours_de_prestation:'---'}} </td>

                            <td>
                              {{f?.Nombre_jours_de_prestation?f?.Nombre_jours_de_prestation +
                              'Jours':'---'}} </td>
 -->


                            <td class="actions">
                              <div class="tools">
                                <div class="dropdown">
                                  <button
                                    class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                    type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">
                                    <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="2.44739" cy="2.44739" r="2.44739"
                                        transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91" />
                                      <circle cx="2.44739" cy="2.44739" r="2.44739"
                                        transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                                      <circle cx="2.44739" cy="2.44739" r="2.44739"
                                        transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                                    </svg>
                                  </button>
                                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a class="cc dropdown-item" (click)="profilFourNavigation(f.id)">Voir Détail
                                    </a>

                                    <!-- <a class="cc dropdown-item" *ngIf="type=='1'"
                                      (click)="openModal(update_Supplier,f)">Modifier </a> -->
                                    <a class="cc dropdown-item" (click)="dissociateSupplier(f.company?.id,'user_id')">Dissocier
                                    </a>

                                    <a class="dropdown-item" routerLink="/contacter-nous">Contact </a>
                                  </div>
                                </div>
                              </div>
                            </td>

                          </tr>


                        </tbody>
                      </table>
                    </div>
                    <div class="pagination" *ngIf="listfournisseurs && listfournisseurs.length">
                      <app-pagination [data]="listfournisseurs" [lengthData]="totalItems" (setPages)="getItems($event)"
                        [currentPageList]="currentPage"> </app-pagination>
                    </div>

                    <div class="alert alert-warning text-center mt-5" role="alert"
                      *ngIf="listfournisseurs && !listfournisseurs.length">
                      <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                      <span class="empty-list">
                        La liste est vide
                      </span>
                    </div>
                  </div>

                </div>
              </div>

              <!--end::Tab pane-->
            </div>
            <!--end::Table-->
          </div>
          <!--end::Card body-->

          <!--end::Card header-->
          <!--begin::Card body-->
          <div class="card-body pt-0" *ngIf="type == 1">
            <div class="tab-content">
              <!--begin::Tab pane-->

              <div id="kt_project_targets_card_pane" class="tab-pane fade">
                <!--begin::Row-->
                <div class="row g-6 g-xl-9 justify-content-center">
                  <!--begin::Col-->
                  <div class="row g-6 g-xl-9 justify-content-center">
                    <!--begin::Col-->
                    <div class="col-md-6 col-xxl-4" *ngFor="let f of listfournisseurs">
                      <div class="card pt-5 p-5">
                        <div class="tools">
                          <div class="dropdown">
                            <button
                              class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                              type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                              aria-expanded="false">
                              <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)"
                                  fill="#265D91" />
                                <circle cx="2.44739" cy="2.44739" r="2.44739"
                                  transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                                <circle cx="2.44739" cy="2.44739" r="2.44739"
                                  transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                              </svg>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                              <a class="cc dropdown-item" (click)="profilEsnNavigation(f.company?.id, f.company?.type)">Voir Détail </a>
                              <a class="cc dropdown-item"
                                (click)="dissociateSupplier(f.company?.id,'fournisseurEsn_id')">Supprimer </a>

                              <a class="cc dropdown-item" *ngIf="type=='1'"
                                (click)="openModal(update_Supplier,f.company)">Modifier </a>
                              <a class="dropdown-item"
                                [routerLink]="['/consultants/consultants-client', f.company?.id]">Voir liste consultant
                              </a>
                              <a class="dropdown-item" routerLink="/contacter-nous">Contact </a>
                            </div>
                          </div>
                        </div>
                        <div class="card-body d-flex flex-center flex-column">
                          <div class="symbol symbol-65px symbol-circle mb-5">

                            <img  class="table-img logo-img" src="{{f?.company?.logo?url+'/Company/file/gallery_company/'+ f?.company?.logo:'/assets/media/icons/avatar.jpg'
                          }}" alt="">
                          </div>

                          <span class="mb-3 company-name">{{f.company?.name}}</span>

                          <div class="content-card">
                            <!-- <div class="py-3 px-4 mx-2">
                              <span class="badge-annee">
                                {{f?.company?.client_final_e_s_n && f.company?.client_final_e_s_n.length > 0 &&
                                f.company?.client_final_e_s_n[0].nb_days?f.company?.client_final_e_s_n[0]?.nb_days
                                :'---'}} Jours
                                préstation</span>
                            </div> -->

                            <div class="py-3 px-4 mx-2">
                              <div class="badge-annee">
                                {{f?.company?.number_of_consultant?f?.company?.number_of_consultant:'---'}} Consultants
                              </div>
                            </div>

                            <div class="py-3 px-4 mx-2">
                              <div class="stars text-center">
                                <rating [(ngModel)]="f.average_note" [max]="5" [readonly]="true">
                                </rating>
                              </div>
                            </div>


                          </div>

                        </div>
                        <div class="foot p-3">
                          <div class="poste">
                            <span class="badge hybrid cursor-pointer"
                              (click)="redirectToSite(f.company?.website_link)">Site
                              web</span>
                          </div>
                          <div class="plus cursor-pointer">
                            <a (click)="profilEsnNavigation(f.company?.id, f.company?.type)">Voir plus</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="alert alert-warning text-center mt-5" role="alert"
                      *ngIf="listfournisseurs && !listfournisseurs.length">
                      <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                      <span class="empty-list">
                        La liste est vide
                      </span>
                    </div>
                  </div>

                </div>
              </div>

              <!--end::Tab pane-->
              <!--begin::Tab pane-->

              <div id="kt_project_targets_table_pane" class="tab-pane fade show active">
                <div class="content">
                  <div class="card-body pt-3">
                    <!--begin::Table-->
                    <div class="table-responsive">
                      <table class="table align-middle fs-6 gy-5 style-table" id="kt_customers_table">
                        <thead>
                          <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">

                            <ng-container *ngFor="let item of listNames ;let i =index">
                              <th class="min-w-225px" [ngClass]="{'th-fixed': item === 'Entreprise'}">
                                <span>{{item}}</span>
                                <i *ngIf="!['Logo'].includes(item)" (click)="sortData(item)"
                                  class="fa-solid fa-sort cursor-pointer"></i>
                              </th>
                            </ng-container>

                            <th class="min-w-90px"><span>Actions</span></th>
                            <th class="min-w-90px">
                              <div class="dropdown" id="table-filter">
                                <button class="btn-centerdropdown-toggle" type="button" id="dropdownMenuButton"
                                  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_d_444_2002)">
                                      <rect x="4" width="20" height="20" rx="4" fill="#63C3E8" fill-opacity="0.12"
                                        shape-rendering="crispEdges" />
                                    </g>
                                    <path
                                      d="M17.5 10.6H14.6V13.5C14.6 13.8314 14.3314 14.1 14 14.1C13.6686 14.1 13.4 13.8314 13.4 13.5V10.6H10.5C10.1686 10.6 9.9 10.3314 9.9 10C9.9 9.66863 10.1686 9.4 10.5 9.4H13.4V6.5C13.4 6.16863 13.6686 5.9 14 5.9C14.3314 5.9 14.6 6.16863 14.6 6.5V9.4H17.5C17.8314 9.4 18.1 9.66863 18.1 10C18.1 10.3314 17.8314 10.6 17.5 10.6Z"
                                      fill="#265D91" stroke="#265D91" stroke-width="0.2" />
                                    <defs>
                                      <filter id="filter0_d_444_2002" x="0" y="0" width="28" height="28"
                                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix"
                                          values="0 0 0 0 0.14902 0 0 0 0 0.364706 0 0 0 0 0.568627 0 0 0 0.13 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                          result="effect1_dropShadow_444_2002" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_444_2002"
                                          result="shape" />
                                      </filter>
                                    </defs>
                                  </svg>
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                  <div class="d-flex checkbox mb-2 menu" *ngFor="let item of dataHeader;let i =index">
                                    <div class="form-check form-check-sm form-check-custom form-check-solid"
                                      *ngIf="item.name!='checkbox'">

                                      <input class="form-check-input checkbox-border"
                                        [checked]="(item.checked=='oui'&&!item.checked_user)||item.checked_user=='oui'&&(item.checked=='non'||item.checked=='oui')"
                                        (change)="changeSelectionElement($event,item,i)" type="checkbox" value="1"
                                        [disabled]="item.name==='Logo' || item.name==='Entreprise'" />
                                      <a class="dropdown-item">{{item.name}}</a>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </th>
                          </tr>


                        </thead>
                        <tbody class="fw-semibold text-gray-600">
                          <tr *ngFor="let f of listfournisseurs">
                            <td *ngIf="listNames.includes('Logo')">  
                              
                              <!-- <img 
                                class="table-img logo-img" src="{{f?.company?.logo?url+'/Company/file/gallery_company/'+ f?.company?.logo:'/assets/media/icons/avatar.jpg'
                                }}" alt=""> -->
                                <img *ngIf="f?.company?.logo" class="table-img logo-img"
                                src="{{url+'/Company/file/gallery_company/'+ f?.company.logo}}"
                                alt="">
                            <img *ngIf="!f.company.logo" class="table-img logo-img"
                                src="/assets/media/icons/avatar.jpg" alt="">
                            

                            </td>
                            <td class="td-fixed" *ngIf="listNames.includes('Entreprise')">
                             
                                <a class="first-td" [routerLink]="[
                                  '/detailcompany', 
                                  f?.company?.id, 
                                  f?.company?.type == 2 ? 'esn' : 
                                  f?.company?.type == 3 ? 'client final' : 
                                  f?.company?.type == 4 ? 'cabinet de recrutement' : ''
                                ]">
                                  {{f?.company?.name}}
                                </a>
                            </td>
                           

                            <td *ngIf="listNames.includes('Consultant')">

                              <span *ngIf="f?.company?.type =='2'">
                                <a routerLink="/consultants/consultants-client/{{f?.company?.id}}"> Voir liste
                                  consultant</a>
                              </span>

                              
                              <span *ngIf="f?.company?.type!=='2'">---</span>

                            </td>

                            <td *ngIf="listNames.includes('Nombre des Consultant ext en mission')">
                              {{f?.company?.nb_consultant_en_mission?f?.nb_consultant_en_mission:'---'}}</td>
                            <!-- days_of_prestation -->

                            <td *ngIf="listNames.includes('Nombre jours de prestation')">
                              {{f?.company?.client_final_e_s_n && f.company?.client_final_e_s_n?.length > 0
                              &&f.company?.client_final_e_s_n[0]?.nb_days
                              ?f.company?.client_final_e_s_n[0]?.nb_days +
                              'Jours':'---'}}
                            </td>

                            <td *ngIf="listNames.includes('Nombre de jours de prestation dernier mois')">
                              {{f?.company?.client_final_e_s_n && f.company?.client_final_e_s_n?.length > 0
                                &&f.company?.client_final_e_s_n[0]?.nb_days
                                ?f.company?.client_final_e_s_n[0]?.nb_days +
                                'Jours':'---'}}
                            </td>

                          

                            <td class="actions">
                              <div class="tools">
                                <div class="dropdown">
                                  <button
                                    class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                    type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">
                                    <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="2.44739" cy="2.44739" r="2.44739"
                                        transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91" />
                                      <circle cx="2.44739" cy="2.44739" r="2.44739"
                                        transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                                      <circle cx="2.44739" cy="2.44739" r="2.44739"
                                        transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                                    </svg>
                                  </button>
                                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a class="cc dropdown-item" (click)="profilEsnNavigation(f.company?.id, f.company?.type)">Voir Détail..
                                    </a>

                                    <a class="cc dropdown-item" (click)="openModal(update_Supplier,f)">Modifier </a>
                                    <a class="cc dropdown-item"
                                      (click)="dissociateSupplier(f.company?.id,'fournisseurEsn_id')">Supprimer </a>
                                    <a class="dropdown-item" [routerLink]="['/consultants/consultants-client', f?.id]"
                                      [ngClass]="{'disabled': f?.company?.type !== '2'}">
                                      Voir liste consultant
                                    </a>
                                    <a class="dropdown-item" routerLink="/contacter-nous">Contact </a>
                                  </div>
                                </div>
                              </div>
                            </td>

                          </tr>


                        </tbody>
                      </table>
                    </div>
                    <div class="pagination" *ngIf="listfournisseurs && listfournisseurs.length">
                      <app-pagination [data]="listfournisseurs" [lengthData]="totalItems" (setPages)="getItems($event)"
                        [currentPageList]="currentPage"> </app-pagination>
                    </div>

                    <div class="alert alert-warning text-center mt-5" role="alert"
                      *ngIf="listfournisseurs && !listfournisseurs.length">
                      <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                      <span class="empty-list">
                        La liste est vide
                      </span>
                    </div>
                  </div>

                </div>
              </div>

              <!--end::Tab pane-->
            </div>
            <!--end::Table-->
          </div>

        </div>

      </div>
      <!--end::Content container-->
    </div>
    <!--end::Content-->
  </div>
  <!--end::Content wrapper-->
  <!--begin::Footer-->

  <!--end::Footer-->
  <!--end:::Main-->
</div>
<!-- ajout fournisseur -->
<ng-template #add_update_Supplier>
  <!--begin::Modal content-->
  <div class="modal-content pt-5 pb-5">
    <!--begin::Modal header-->
    <div class="modal-header">
      <!--begin::Modal title-->
      <h2 class="fw-bold"> Ajouter Fournisseur</h2>
      <!--end::Modal title-->
      <!--begin::Close-->
      <div id="ModalClose_add_fournisseur" class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal"
        (click)="closeModal()">
        <i class="ki-duotone ki-cross fs-1">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
      </div>
      <!--end::Close-->
    </div>

    <!--end::Modal header-->
    <!--begin::Modal body-->
    <div class="modal-body add_four mx-5 my-7">
      <!--begin::Form-->
      <form [formGroup]="formfournisseur">
        <div class="">
          <div class="card-body">

            <div class="mb-3">
              <label for="fournisseur" class="required mb-3">Nom Fournisseur </label>
             <input type="text"  id="NomF" class="form-control mb-3" placeholder="Nom fournisseur" formControlName="name"
                (keyup)="onSearch($event)" />

              <div *ngIf="formfournisseur.get('name')?.hasError('required') && formfournisseur.get('name')?.touched"
                class="text-danger">
                Le champ " Nom Fournisseur " est obligatoire.
              </div>

            </div>
            <div class="mb-5">
              <label for="linkedin_link">Linkedin </label>
              <input type="text" name="linkedin" id="linkedin" class="form-control"
                placeholder="https://www.linkedin.com/company/" formControlName="linkedin_link"
                (change)="setValidatorRequirements()">

              <!-- <app-feild-error [control]="formfournisseur.get('linkedin_link')"></app-feild-error> -->

              <div *ngIf="
             formfournisseur.get('linkedin_link')?.hasError('pattern') &&
              formfournisseur.get('linkedin_link')?.touched
              " class="text-danger">
                Entrer une URL valide exemple:
                https://www.linkedin.com/company/exemple
              </div>
            </div>

            <div class="mb-5">
              <label for="website_link">Site web </label>
              <input type="text" name="website_link" id="website_link" class="form-control"
                placeholder=" https://www.exemple.com ou www.exemple.fr"
                formControlName="website_link" (change)="setValidatorRequirements()">

              <app-feild-error class="mt-3" [control]="formfournisseur.get('website_link')"></app-feild-error>
            </div>
            <span class="requirements mt-5"> <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_379_198)">
                  <path
                    d="M8 16C9.58225 16 11.129 15.5308 12.4446 14.6518C13.7602 13.7727 14.7855 12.5233 15.391 11.0615C15.9965 9.59966 16.155 7.99113 15.8463 6.43928C15.5376 4.88743 14.7757 3.46197 13.6569 2.34315C12.538 1.22433 11.1126 0.462403 9.56072 0.153721C8.00887 -0.15496 6.40034 0.00346629 4.93853 0.608967C3.47672 1.21447 2.22729 2.23985 1.34824 3.55544C0.469192 4.87104 0 6.41775 0 8C0.00229405 10.121 0.845886 12.1545 2.34568 13.6543C3.84547 15.1541 5.87897 15.9977 8 16ZM8 3.33334C8.19778 3.33334 8.39112 3.39199 8.55557 3.50187C8.72002 3.61175 8.84819 3.76793 8.92388 3.95065C8.99957 4.13338 9.01937 4.33445 8.98079 4.52843C8.9422 4.72241 8.84696 4.90059 8.70711 5.04044C8.56726 5.1803 8.38907 5.27554 8.19509 5.31412C8.00111 5.35271 7.80004 5.3329 7.61732 5.25722C7.43459 5.18153 7.27841 5.05336 7.16853 4.88891C7.05865 4.72446 7 4.53112 7 4.33334C7 4.06812 7.10536 3.81377 7.29289 3.62623C7.48043 3.43869 7.73478 3.33334 8 3.33334ZM7.33333 6.66667H8C8.35362 6.66667 8.69276 6.80715 8.94281 7.0572C9.19286 7.30724 9.33333 7.64638 9.33333 8V12C9.33333 12.1768 9.2631 12.3464 9.13807 12.4714C9.01305 12.5964 8.84348 12.6667 8.66667 12.6667C8.48986 12.6667 8.32029 12.5964 8.19526 12.4714C8.07024 12.3464 8 12.1768 8 12V8H7.33333C7.15652 8 6.98695 7.92977 6.86193 7.80474C6.73691 7.67972 6.66667 7.51015 6.66667 7.33334C6.66667 7.15653 6.73691 6.98696 6.86193 6.86193C6.98695 6.73691 7.15652 6.66667 7.33333 6.66667Z"
                    fill="#2b5d8f" />
                </g>
                <defs>
                  <clipPath id="clip0_379_198">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>


              </svg> &nbsp;Au moins l'un des champs web site ou LinkedIn est requis.</span> <br><br>



            <div class="mb-3">
              <label for="pays" class="mb-3">Pays </label>
              <ng-select (change)="onCountryChange($event)" [items]="paysList" [notFoundText]="'Aucun élément trouvé'"
                formControlName="country" bindLabel="name" bindValue="name" [placeholder]="'Pays'" autoComplete>
              </ng-select>

            </div>
            <div class="mb-3">
              <label for="pays" class="mb-3">
                Ville </label>
              <ng-select [items]="stateList" bindLabel="name" formControlName="address"
                [notFoundText]="'Aucun élément trouvé'" bindValue="name" [placeholder]="'
              Ville'" autoComplete>
              </ng-select>

            </div>

            <div *ngIf="!isexiste"class="mb-3">
              <label for="creation">Année de création </label> &nbsp;&nbsp; <i class="fa fa-calendar"></i>
              <br>
              <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" view="year" dateFormat="yy"
                placeholder="Année" inputId="yearpicker" formControlName="year_of_creation"
                class="form-control"></p-calendar>
               
            </div>
            <div *ngIf="isexiste"class="mb-3">
              <label for="creation">Année de création </label> &nbsp;&nbsp; <i class="fa fa-calendar"></i>
              <br>
              <input type="text" id="Nom" class="form-control mb-3" placeholder="date de création"
              formControlName="year_of_creation" [readonly]="true" />
               
            </div>

            <div class="mb-3">
              <label for="fournisseur" class="mb-3">Nom Vis à vis </label>
              <input type="text" id="Nom" class="form-control mb-3" placeholder="Nom Vis à vis"
                formControlName="related_first_name_client" />

            </div>

            <div class="mb-3">
              <label for="Prénom" class="mb-3">Prénom Vis à vis </label>
              <input type="text" id="Nom" class="form-control mb-3" placeholder="Prénom Vis à vis"
                formControlName="related_last_name_client" />

            </div>

            <div class="mb-3">
              <label for="mail" class="mb-3">Contact Email vis à vis </label>
              <input type="email" id="Prénom" class="form-control mb-3" placeholder="adresse@gmail.com"
                formControlName="related_email_client" />

              <div
                *ngIf="formfournisseur.get('related_email_client')?.hasError('pattern') && formfournisseur.get('related_email_client')?.touched"
                class="text-danger">
                La valeur de ce champ doit avoir une adresse email valide.
              </div>
            </div>

            <div class="mb-3">
              <label for="Téléphone" class="mb-3">Téléphone vis à vis </label>
              <!-- <input type="tel" id="Prénom" class="form-control mb-3" placeholder="Téléphone" formControlName="related_phone_client"/> -->

              <form [formGroup]="phoneForm">
                <div class="wrapper  ">
                  <ngx-intl-tel-input [cssClass]="'form-control'" [preferredCountries]="preferredCountries"
                      [searchCountryPlaceholder]="'Rechercher un pays'"
                    [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                    [searchCountryField]="[SearchCountryField.Iso2,SearchCountryField.Name]"
                    [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.France" [maxLength]="20"
                    [phoneValidation]="true" [separateDialCode]="separateDialCode"
                    [numberFormat]="PhoneNumberFormat.National" name="phone" formControlName="phone">
                  </ngx-intl-tel-input>

                </div>
              </form>
              <div *ngIf="phoneForm.controls['phone'].invalid && phoneForm.controls['phone'].touched">
                <span class="text-danger">Numéro de téléphone est
                  invalide</span>
              </div>
            </div>





            <!-- <div class="mb-3">
              <label for="jours" class="mb-3">Nombre jours de prestation</label>
              <input type="number" id="nbr_jr" class="form-control mb-3" min="0" oninput="validity.valid||(value='0');"
                placeholder="Nombre de jours" formControlName="nb_days" />



            </div>

            <div class="mb-3">
              <label for="prestation" class="mb-3">Date de la première prestation </label>
              <input type="text" id="Nom" class="form-control mb-3" placeholder="Date de la première prestation"
                formControlName="date_first_presentation" onfocus="(this.type='date')"   onblur="(this.type='text')" />
                
            </div> -->




          </div>
        </div>
        <!--end::Form-->
      </form>
    </div>
    <div class="card-footer mx-5 my-5">
      <div class="actions mx-5">
        <a class="annuler" href="" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()">Annuler</a>
        <button class="confirmer" [disabled]="formfournisseur.invalid" (click)="createfournisseur()">Confirmer</button>
      </div>
    </div>
    <!--end::Modal body-->
  </div>
  <!--end::Modal content-->
</ng-template>


<ng-template #add_update_Supplier_Individual>

  <!--begin::Modal content-->
  <div class="modal-content pt-5 pb-15">
    <!--begin::Modal header-->
    <div class="modal-header">
      <!--begin::Modal title-->
      <h2 class="fw-bold">Ajouter fournisseur Individuel </h2>
      <!--end::Modal title-->
      <!--begin::Close-->
      <div id="ModalClose_add_fournisseur" class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal"
        aria-label="Close" (click)="closeModal()">
        <i class="ki-duotone ki-cross fs-1">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
      </div>
      <!--end::Close-->
    </div>

    <!--end::Modal header-->
    <!--begin::Modal body-->
    <div class="modal-body four_indi mx-5 my-7">
      <!--begin::Form-->
      <form [formGroup]="formfournisseurind">
        <div class="">
          <div class="card-body">

            <div class="mb-3">
              <label for="mail" class="mb-3" class="required mb-3">Email personel </label>
              <input type="email" id="ContactEmail" class="form-control mb-3" placeholder="adresse@gmail.com"
                formControlName="fournisseur_email" (keyup)="applyFilterEmail($event)" />
              <div
                *ngIf="formfournisseurind.get('fournisseur_email')?.hasError('required') && formfournisseurind.get('fournisseur_email')?.touched"
                class="text-danger">
                Le champ " Email personel " est obligatoire.
              </div>
              <div
                *ngIf="formfournisseurind.get('fournisseur_email')?.hasError('pattern') && formfournisseurind.get('fournisseur_email')?.touched"
                class="text-danger">
                La valeur de ce champ doit avoir une adresse email valide.
              </div>
            </div>
            <div class="mb-3">
              <label for="fournisseur" class="required mb-3">Nom Fournisseur </label>
              <input type="text" id="Nom" class="form-control mb-3" placeholder="Nom fournisseur"
                formControlName="fournisseur_first_name" />

              <div
                *ngIf="formfournisseurind.get('fournisseur_first_name')?.hasError('required') && formfournisseurind.get('fournisseur_first_name')?.touched"
                class="text-danger">
                Le champ " Nom Fournisseur " est obligatoire.
              </div>
            </div>

            <div class="mb-3">
              <label for="Prénom" class="mb-3" class="required mb-3">Prénom Fournisseur </label>
              <input type="text" id="Nom" class="form-control mb-3" formControlName="fournisseur_last_name"
                placeholder="Prénom Vis à vis" />
              <div
                *ngIf="formfournisseurind.get('fournisseur_last_name')?.hasError('required') && formfournisseurind.get('fournisseur_last_name')?.touched"
                class="text-danger">
                Le champ " Prénom Fournisseur " est obligatoire.
              </div>

            </div>


            <div class="mb-5">
              <label for="linkedin_link">Linkedin </label>
              <input type="text" id="Linkedin" class="form-control mb-3"
                placeholder="Entrez votre lien LinkedIn (ex. https://www.linkedin.com/in/votreprofil)"
                formControlName="linkedin_link" />

              <div *ngIf="
              formfournisseurind.get('linkedin_link')?.hasError('pattern') &&
              formfournisseurind.get('linkedin_link')?.touched
              " class="text-danger">
                Entrer une URL valide exemple:
                https://www.linkedin.com/in/exemple
              </div>

            </div>


            <div class="mb-3">
              <label for="Téléphone" class="mb-3">Téléphone </label>


              <form [formGroup]="phoneForm">
                <div class="wrapper  ">
                  <ngx-intl-tel-input [cssClass]="'form-control'" [preferredCountries]="preferredCountries"
                      [searchCountryPlaceholder]="'Rechercher un pays'"
                    [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                    [searchCountryField]="[SearchCountryField.Iso2,SearchCountryField.Name]"
                    [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.France" [maxLength]="20"
                    [phoneValidation]="true" [separateDialCode]="separateDialCode"
                    [numberFormat]="PhoneNumberFormat.National" name="phone" formControlName="phone">
                  </ngx-intl-tel-input>

                </div>


              </form>
              <div *ngIf="phoneForm.controls['phone'].invalid && phoneForm.controls['phone'].touched">
                <span class="text-danger">Numéro de téléphone est
                  invalide</span>
              </div>
            </div>


            <!-- <div class="mb-3">
              <label for="jours" class="mb-3">Nombre jours de préstation</label>
              <input type="text" id="nbr_jr" class="form-control mb-3" min="0" placeholder="Nombre de jours"
                formControlName="nb_days" />

              <div
                *ngIf="formfournisseur.get('nb_days')?.hasError('required') && formfournisseur.get('nb_days')?.touched"
                class="text-danger">
                Le champ " Nombre de jours " est obligatoire.
              </div>
              <div
                *ngIf="formfournisseur.get('nb_days')?.hasError('pattern') && formfournisseur.get('nb_days')?.touched"
                class="text-danger">
                La valeur de ce champ doit avoir un nombre valide
              </div>
            </div>

            <div class="mb-3">
              <label for="prestation" class="mb-3">Date de la première préstation </label>
              <input type="date" id="Nom" class="form-control mb-3" placeholder="jj/mm/aaaa"
                formControlName="date_first_presentation"  [min]="currentDate"/>
              <div
                *ngIf="formfournisseur.get('date_first_presentation')?.hasError('required') && formfournisseur.get('date_first_presentation')?.touched"
                class="text-danger">
                Le champ " Date de première préstation " est obligatoire.
              </div>
            </div> -->




          </div>
        </div>
        <!--end::Form-->
      </form>
    </div>
    <div class="card-footer mx-5 mx-xl-15 my-7">
      <div class="actions">
        <a class="annuler" href="" data-bs-dismiss="modal" aria-label="Close" (click)="close_modal_add()">Annuler</a>
        <button class="confirmer" [disabled]="formfournisseurind.invalid"
          (click)="createfournisseurindividuel()">Confirmer</button>
      </div>
    </div>
    <!--end::Modal body-->
  </div>
  <!--end::Modal content-->

</ng-template>

<div class="modal fade" id="details_salarie" tabindex="-1" aria-hidden="true">
  <!--begin::Modal dialog-->
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <!--begin::Modal content-->
    <div class="modal-content">
      <!--begin::Form-->
      <form class="form" action="#" id="kt_modal_add_customer_form"
        data-kt-redirect="../../demo1/dist/apps/customers/list.html">
        <!--begin::Modal header-->
        <div class="modal-header" id="kt_modal_add_customer_header">
          <!--begin::Modal title-->
          <h2 class="">Voir Détail Entreprise</h2>
          <!--end::Modal title-->
          <!--begin::Close-->
          <div id="kt_modal_add_customer_close" data-bs-dismiss="modal"
            class="btn btn-icon btn-sm btn-active-icon-primary">
            <i class="ki-duotone ki-cross fs-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </div>
          <!--end::Close-->
        </div>
        <!--end::Modal header-->
        <!--begin::Modal body-->
        <div class="modal-body py-10 px-lg-17 tools">
          <!--begin::Scroll-->
          <div class="scroll-y me-n7 pe-7" id="kt_modal_add_customer_scroll" data-kt-scroll="true"
            data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto"
            data-kt-scroll-dependencies="#kt_modal_add_customer_header"
            data-kt-scroll-wrappers="#kt_modal_add_customer_scroll" data-kt-scroll-offset="300px">
            <!--begin::Input group-->


            <div class="row">
              <div class="col-lg-6">
                <div class="fv-row mb-7 ">
                  <!--begin::Label-->
                  <label class=" fs-6 fw-semibold mb-2">Type</label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <input *ngIf="detailfournisseur?.type=='2'" type="text" disabled
                    class="form-control form-control-solid mb-3" placeholder="" name="module" value="ESN" />
                  <input *ngIf="detailfournisseur?.type=='5'" type="text" disabled
                    class="form-control form-control-solid mb-3" placeholder="" name="module" value="Individuel" />

                  <!--end::Input-->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="fv-row mb-7 ">
                  <!--begin::Label-->
                  <label class=" fs-6 fw-semibold mb-2">Nom entreprise</label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <input type="text" disabled class="form-control form-control-solid mb-3" placeholder="" name="module"
                    value="{{detailfournisseur?.name}}" />
                  <!--end::Input-->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="fv-row mb-7 ">
                  <!--begin::Label-->
                  <label class=" fs-6 fw-semibold mb-2">Domaine</label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <input type="text" disabled class="form-control form-control-solid mb-3" placeholder="" name="module"
                    value="{{detailfournisseur?.domain}}" />
                  <!--end::Input-->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="fv-row mb-7">
                  <!--begin::Label-->
                  <label class=" fs-6 fw-semibold mb-2">Nbre de salarié </label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <input type="text" disabled class="form-control form-control-solid mb-3" placeholder="" name="module"
                    value="{{detailfournisseur?.number_of_salaries}}" />
                  <!--end::Input-->
                </div>
              </div>
            </div>



            <div class="row">
              <div class="col-lg-6">
                <div class="fv-row mb-7 ">
                  <!--begin::Label-->
                  <label class=" fs-6 fw-semibold mb-2"> Adresse </label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <input type="text" disabled class="form-control form-control-solid mb-3" placeholder="" name="module"
                    value="{{detailfournisseur?.address}}" />
                  <!--end::Input-->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="fv-row mb-7 ">
                  <!--begin::Label-->
                  <label class=" fs-6 fw-semibold mb-2">Année De Création </label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <input type="text" disabled class="form-control form-control-solid mb-3" placeholder="" name="module"
                    value="{{detailfournisseur?.year_of_creation}}" />
                  <!--end::Input-->
                </div>
              </div>


            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="fv-row mb-7 ">
                  <!--begin::Label-->
                  <label class=" fs-6 fw-semibold mb-2"> Linkedin </label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <input type="text" disabled class="form-control form-control-solid mb-3" placeholder="" name="module"
                    value="{{detailfournisseur?.linkedin_link}}" />
                  <!--end::Input-->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="fv-row mb-7 ">
                  <!--begin::Label-->
                  <label class=" fs-6 fw-semibold mb-2">Site web</label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <input type="text" disabled class="form-control form-control-solid mb-3" placeholder="" name="module"
                    value="{{detailfournisseur?.website_link }}" />
                  <!--end::Input-->
                </div>
              </div>


            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="fv-row mb-7 ">
                  <!--begin::Label-->
                  <label class=" fs-6 fw-semibold mb-2"> Ville </label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <input type="text" disabled class="form-control form-control-solid mb-3" placeholder="" name="module"
                    value="{{detailfournisseur?.city}}" />
                  <!--end::Input-->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="fv-row mb-7 ">
                  <!--begin::Label-->
                  <label class=" fs-6 fw-semibold mb-2">Pays</label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <input type="text" disabled class="form-control form-control-solid mb-3" placeholder="" name="module"
                    value="{{detailfournisseur?.country}}" />
                  <!--end::Input-->
                </div>
              </div>


            </div>


            <div class="row">
              <div class="col-lg-6">
                <div class="fv-row mb-7 ">
                  <!--begin::Label-->
                  <label class=" fs-6 fw-semibold mb-2"> Nbre demandes d'emploi </label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <input type="text" disabled class="form-control form-control-solid mb-3" placeholder="" name="module"
                    value="{{detailfournisseur?.nb_job_request}}" />
                  <!--end::Input-->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="fv-row mb-7 ">
                  <!--begin::Label-->
                  <label class=" fs-6 fw-semibold mb-2"> Nbre offre d'emploi </label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <input type="text" disabled class="form-control form-control-solid mb-3" placeholder="" name="module"
                    value="{{detailfournisseur?.nb_job_offer}}" />
                  <!--end::Input-->
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="fv-row mb-7 ">
                    <!--begin::Label-->
                    <label class=" fs-6 fw-semibold mb-2"> Nbre cra </label>
                    <!--end::Label-->
                    <!--begin::Input-->
                    <input type="text" disabled class="form-control form-control-solid mb-3" placeholder=""
                      name="module" value="{{detailfournisseur?.nb_cra}}" />
                    <!--end::Input-->
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="fv-row mb-7 ">
                    <!--begin::Label-->
                    <label class=" fs-6 fw-semibold mb-2">Nbre d'intervenant</label>
                    <!--end::Label-->
                    <!--begin::Input-->
                    <input type="text" disabled class="form-control form-control-solid mb-3" placeholder=""
                      name="module" value="{{detailfournisseur?.number_of_intervenant}}" />
                    <!--end::Input-->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::Scroll-->
        </div>
        <!--end::Modal body-->

      </form>
      <!--end::Form-->
    </div>
  </div>
</div>
<ng-template #add_masse>
  <div class="modal-content" id="add_masse" tabindex="-1" aria-hidden="true">
    <!--begin::Modal dialog-->
    <!--begin::Modal content-->
    <div class="">
      <!--begin::Modal content-->
      <div class="content">
        <!--begin::Modal header-->
        <div class="modal-header">
          <!--begin::Modal title-->
          <h2 class="">Ajouter en masse</h2>
          <!--end::Modal title-->
          <!--begin::Close-->
          <div id="kt_customers_export_close" data-bs-dismiss="modal"
            class="btn btn-icon btn-sm btn-active-icon-primary">
            <i class="ki-duotone ki-cross fs-1" (click)="closeModal()">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </div>
          <!--end::Close-->
        </div>
        <!--end::Modal header-->
        <!--begin::Modal body-->
        <div class="modal-body scroll-y mx-5 mx-xl-15 my-7">

          <label for="masse">Votre ficher CSV</label>
          <input type="file" name="masse" id="masse" class="form-control" (change)="onFileSelected($event)">
          <span style="color:red" *ngIf="fileExtentions"><small>{{fileExtentions}} </small></span>
          <div class="modal-footer">
            <button type="reset" (click)="closeModal()" id="kt_customers_export_cancel" data-bs-dismiss="modal"
              class="footer-btn annuler me-3">Annuler</button>
            <button [disabled]="fileExtentions!='' || !selectedFile" type="submit" id="kt_customers_export_submit"
              (click)="addBulkCandidates()" class="footer-btn confirmer ">
              <span class="indicator-label">Confirmer</span>
              <span class="indicator-progress">Please wait...
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
            </button>
          </div>
          <!--end::Form-->
        </div>
        <!--end::Modal body-->
      </div>
    </div>
  </div>
</ng-template>
<ng-template #update_Supplierind>
  <!--begin::Modal content-->
  <div class="modal-content pt-5 pb-15">
    <!--begin::Modal header-->
    <div class="modal-header">
      <!--begin::Modal title-->
      <h2 class="fw-bold">Modifier Fournisseur Individuel </h2>
      <!--end::Modal title-->
      <!--begin::Close-->
      <div id="ModalClose_add_fournisseur" class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal"
        aria-label="Close" (click)="closeModal()">
        <i class="ki-duotone ki-cross fs-1">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
      </div>
      <!--end::Close-->
    </div>

    <!--end::Modal header-->
    <!--begin::Modal body-->
    <div class="modal-body mx-5 mx-xl-15 my-7">
      <!--begin::Form-->
      <form [formGroup]="formfournisseurind">
        <div class="">
          <div class="card-body">

            <div class="mb-3">
              <label for="mail" class="mb-3" class="required mb-3">Email personel </label>
              <input type="email" id="ContactEmail" class="form-control mb-3" placeholder="adresse@gmail.com"
                formControlName="fournisseur_email" />


            </div>
            <div class="mb-3">
              <label for="fournisseur" class="required mb-3">Nom Fournisseur </label>
              <input type="text" id="Nom" class="form-control mb-3" placeholder="Nom fournisseur"
                formControlName="fournisseur_first_name" />

              <div
                *ngIf="formfournisseur.get('fournisseurName')?.hasError('required') && formfournisseur.get('fournisseurName')?.touched"
                class="text-danger">
                Le champ " Nom Fournisseur " est obligatoire.
              </div>
            </div>

            <div class="mb-3">
              <label for="Prénom" class="mb-3" class="required mb-3">Prénom Fournisseur </label>
              <input type="text" id="Nom" class="form-control mb-3" formControlName="fournisseur_last_name"
                placeholder="Prénom Vis à vis" />

            </div>


            <div class="mb-5">
              <label for="linkedin_link">Linkedin </label>
              <input type="text" id="Linkedin" class="form-control mb-3"
                placeholder="Entrez votre lien LinkedIn (ex. https://www.linkedin.com/in/votreprofil)"
                formControlName="linkedin_link" />

              <div
                *ngIf="formfournisseur.get('linkedin_link')?.hasError('required') && formfournisseur.get('linkedin_link')?.touched"
                class="text-danger">
                Le champ "Lien LinkedIn" est obligatoire.
              </div>
              <div
                *ngIf="formfournisseur.get('linkedin_link')?.hasError('pattern') && formfournisseur.get('linkedin_link')?.touched"
                class="text-danger">
                Le format du lien LinkedIn n'est pas valide.
              </div>

            </div>

            <div class="mb-3">
              <label for="linkedin_link">Téléphone </label>
              <label for="Téléphone" class="mb-3"> </label>
              <input type="tel" id="Prénom" class="form-control mb-3" placeholder="Téléphone"
                formControlName="fournisseurPhone" />


            </div>



            <div class="mb-3">
              <label for="jours" class="mb-3">Nombre jours de préstation</label>
              <input type="number" id="nbr_jr" class="form-control mb-3" min="0" placeholder="Nombre de jours"
                formControlName="nb_days" />

              <div
                *ngIf="formfournisseur.get('nb_days')?.hasError('required') && formfournisseur.get('nb_days')?.touched"
                class="text-danger">
                Le champ " Nombre de jours " est obligatoire.
              </div>
              <div
                *ngIf="formfournisseur.get('nb_days')?.hasError('pattern') && formfournisseur.get('nb_days')?.touched"
                class="text-danger">
                La valeur de ce champ doit avoir un nombre valide
              </div>
            </div>

            <div class="mb-3">
              <label for="prestation" class="mb-3">Date de la première prestation </label>
              <input type="date" id="Nom" class="form-control mb-3" placeholder="jj/mm/aaaa"
                formControlName="date_first_presentation" />

              <div
                *ngIf="formfournisseur.get('date_first_presentation')?.hasError('required') && formfournisseur.get('date_first_presentation')?.touched"
                class="text-danger">
                Le champ " Date de première prestation " est obligatoire.
              </div>
            </div>




          </div>
        </div>
        <!--end::Form-->
      </form>
    </div>
    <div class="card-footer mx-5 mx-xl-15 my-7">
      <div class="actions">
        <a class="annuler" href="" data-bs-dismiss="modal" aria-label="Close" (click)="close_modal_add()">Annuler</a>
        <a class="confirmer" (click)="updateSupplierindiv()">Confirmer</a>
      </div>
    </div>
    <!--end::Modal body-->
  </div>
  <!--end::Modal content-->
</ng-template>
<ng-template #update_Supplier>
  <!--begin::Modal content-->
  <div class="modal-content pt-5 pb-15">
    <!--begin::Modal header-->
    <div class="modal-header">
      <!--begin::Modal title-->
      <h2 class="fw-bold"> Modifier Fournisseur ESN</h2>
      <!--end::Modal title-->
      <!--begin::Close-->
      <div id="ModalClose_add_fournisseur" class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal"
        (click)="closeModal()">
        <i class="ki-duotone ki-cross fs-1">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
      </div>
      <!--end::Close-->
    </div>

    <!--end::Modal header-->
    <!--begin::Modal body-->
    <div class="modal-body add_four mx-5 my-7">
      <!--begin::Form-->
      <form [formGroup]="formfournisseur">
        <div class="">
          <div class="card-body">

            <div class="mb-3">
              <label for="fournisseur" class="required mb-3">Nom Fournisseur </label>
              <input type="text" id="Nom" class="form-control mb-3" placeholder="Nom fournisseur" formControlName="name"
                readonly />

              <div *ngIf="formfournisseur.get('name')?.hasError('required') && formfournisseur.get('name')?.touched"
                class="text-danger">
                Le champ " Nom Fournisseur " est obligatoire.
              </div>
            </div>
            <div class="mb-5">
              <label for="linkedin_link">Linkedin </label>
              <input type="text" name="linkedin" id="linkedin" class="form-control"
                placeholder="https://www.linkedin.com/company/" formControlName="linkedin_link"
                (change)="setValidatorRequirements()">

              <!-- <app-feild-error [control]="formfournisseur.get('linkedin_link')"></app-feild-error> -->

              <div *ngIf="
             formfournisseur.get('linkedin_link')?.hasError('pattern') &&
              formfournisseur.get('linkedin_link')?.touched
              " class="text-danger">
                Entrer une URL valide exemple:
                https://www.linkedin.com/company/exemple
              </div>
            </div>

            <div class="mb-5">
              <label for="website_link">Site web </label>
              <input type="text" id="site_web" class="form-control mb-3"
                placeholder="Entrez votre site web (ex. https://www.votresiteweb.com)" formControlName="website_link"
                [readonly]="true" />

              <div
                *ngIf="formfournisseur.get('website_link')?.hasError('pattern') && formfournisseur.get('website_link')?.touched"
                class="text-danger">
                Le format du site web n'est pas valide.
              </div>
            </div>
            <span class="requirements mt-5"> <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_379_198)">
                  <path
                    d="M8 16C9.58225 16 11.129 15.5308 12.4446 14.6518C13.7602 13.7727 14.7855 12.5233 15.391 11.0615C15.9965 9.59966 16.155 7.99113 15.8463 6.43928C15.5376 4.88743 14.7757 3.46197 13.6569 2.34315C12.538 1.22433 11.1126 0.462403 9.56072 0.153721C8.00887 -0.15496 6.40034 0.00346629 4.93853 0.608967C3.47672 1.21447 2.22729 2.23985 1.34824 3.55544C0.469192 4.87104 0 6.41775 0 8C0.00229405 10.121 0.845886 12.1545 2.34568 13.6543C3.84547 15.1541 5.87897 15.9977 8 16ZM8 3.33334C8.19778 3.33334 8.39112 3.39199 8.55557 3.50187C8.72002 3.61175 8.84819 3.76793 8.92388 3.95065C8.99957 4.13338 9.01937 4.33445 8.98079 4.52843C8.9422 4.72241 8.84696 4.90059 8.70711 5.04044C8.56726 5.1803 8.38907 5.27554 8.19509 5.31412C8.00111 5.35271 7.80004 5.3329 7.61732 5.25722C7.43459 5.18153 7.27841 5.05336 7.16853 4.88891C7.05865 4.72446 7 4.53112 7 4.33334C7 4.06812 7.10536 3.81377 7.29289 3.62623C7.48043 3.43869 7.73478 3.33334 8 3.33334ZM7.33333 6.66667H8C8.35362 6.66667 8.69276 6.80715 8.94281 7.0572C9.19286 7.30724 9.33333 7.64638 9.33333 8V12C9.33333 12.1768 9.2631 12.3464 9.13807 12.4714C9.01305 12.5964 8.84348 12.6667 8.66667 12.6667C8.48986 12.6667 8.32029 12.5964 8.19526 12.4714C8.07024 12.3464 8 12.1768 8 12V8H7.33333C7.15652 8 6.98695 7.92977 6.86193 7.80474C6.73691 7.67972 6.66667 7.51015 6.66667 7.33334C6.66667 7.15653 6.73691 6.98696 6.86193 6.86193C6.98695 6.73691 7.15652 6.66667 7.33333 6.66667Z"
                    fill="#2b5d8f" />
                </g>
                <defs>
                  <clipPath id="clip0_379_198">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>

              </svg> &nbsp;Au moins l'un des champs web site ou LinkedIn est requis.</span> <br><br>



            <div class="mb-3">
              <label for="pays" class="mb-3">Pays </label>
              <ng-select (change)="onCountryChange($event)" [items]="paysList" [notFoundText]="'Aucun élément trouvé'"
                formControlName="country" bindLabel="name" bindValue="name" [placeholder]="'Pays'"
                autoComplete>
              </ng-select>

            </div>
            <div class="mb-3">
              <label for="pays" class="mb-3">Ville </label>
              <ng-select [items]="stateList" [ngClass]="{'disable-select':!stateList?.length}" [attr.disabled]="!stateList?.length ? true : null" bindLabel="name" formControlName="address"
                [notFoundText]="'Aucun élément trouvé'" bindValue="name" [placeholder]="'Ville'" autoComplete>
              </ng-select>

            </div>

            <div class="mb-3">
              <label for="creation">Année de création </label>
              <input type="text" id="Nom" class="form-control mb-3" placeholder="date de création"
                formControlName="year_of_creation" [readonly]="true" />
            </div>

            <div class="mb-3">
              <label for="fournisseur" class="mb-3">Nom Vis à vis </label>
              <input type="text" id="Nom" class="form-control mb-3" placeholder="Nom Vis à vis"
                formControlName="related_first_name_client" />

            </div>

            <div class="mb-3">
              <label for="Prénom" class="mb-3">Prénom Vis à vis </label>
              <input type="text" id="Nom" class="form-control mb-3" placeholder="Prénom Vis à vis"
                formControlName="related_last_name_client" />

            </div>

            <div class="mb-3">
              <label for="mail" class="mb-3">Contact Email vis à vis </label>
              <input type="email" id="Prénom" class="form-control mb-3" placeholder="adresse@gmail.com"
                formControlName="related_email_client" />


            </div>

            <div class="mb-3">
              <label for="Téléphone" class="mb-3">Téléphone vis à vis </label>
             

                <div class="wrapper ">
                  <ngx-intl-tel-input [cssClass]="'form-control'" [preferredCountries]="preferredCountries"
                      [searchCountryPlaceholder]="'Rechercher un pays'"
                    [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                    [searchCountryField]="[SearchCountryField.Iso2,SearchCountryField.Name]"
                    [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.France" [maxLength]="20"
                    [phoneValidation]="true" [separateDialCode]="separateDialCode"
                    [numberFormat]="PhoneNumberFormat.National" name="phone" formControlName="related_phone_client">
                  </ngx-intl-tel-input>

                </div>
              <div *ngIf="formfournisseur.controls['related_phone_client'].invalid && formfournisseur.controls['related_phone_client'].touched">
                <span class="text-danger">Numéro de téléphone est
                  invalide</span>
              </div>
            </div>

            <!-- <div class="mb-3">
              <label for="jours" class="mb-3">Nombre jours de prestation</label>
              <input type="number" id="nbr_jr" class="form-control mb-3" min="0" placeholder="Nombre de jours"
                formControlName="nb_days" />

            </div>

            <div class="mb-3">
              <label for="prestation" class="mb-3">Date de la première prestation </label>
              <input type="text" id="Nom" class="form-control mb-3" placeholder="Date de la première prestation"
                formControlName="date_first_presentation" onfocus="(this.type='date')"  onblur="(this.type='text')" />
            </div> -->




          </div>
        </div>
        <!--end::Form-->
      </form>
    </div>
    <div class="card-footer mx-5 mx-xl-15 my-7">
      <div class="actions">
        <a class="annuler" href="" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()">Annuler</a>
        <button class="confirmer"  [disabled]="formfournisseur.invalid " (click)="updateSupplier()">Confirmer</button>
      </div>
    </div>
    <!--end::Modal body-->
  </div>
  <!--end::Modal content-->
</ng-template>